import styled from 'styled-components';
import type { LinkProps } from './types';

const StyledLink = styled.a`
  font-size: 13px;
  text-decoration: underline;
  display: inline-flex;
  max-width: fit-content;
`;

function Link(props: LinkProps) {
  return (
    <StyledLink
      target={props.target}
      href={props.href}
      onClick={props.onClick}
    >
      {props.children}
    </StyledLink>
  );
}

export default Link;
